import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      backgroundColor: theme.colors.blue[0],
      paddingTop: rem(80),
      paddingBottom: rem(80),
      [theme.fn.smallerThan('sm')]: {
        paddingTop: rem(40),
        paddingBottom: rem(40),
      },
    },
    container: {
      display: 'flex',
      [theme.fn.smallerThan('sm')]: { flexDirection: 'column', gap: rem(24) },
      [theme.fn.largerThan('sm')]: {
        gap: rem(48),
        justifyContent: 'space-between',
      },
    },
    icon: {
      width: rem(64),
    },
    iconWrapper: {
      flexShrink: 0,
    },
    heading: {},
    info: {
      display: 'flex',
      gap: rem(16),
      alignItems: 'center',
      [theme.fn.largerThan('sm')]: {
        flexDirection: 'column',
        gap: rem(24),
        alignItems: 'flex-start',
      },
    },
    infoTop: {
      display: 'flex',
      flexDirection: 'column',
      gap: rem(24),
    },
    infoCol: {
      display: 'flex',
      flexDirection: 'column',
      gap: rem(24),
      maxWidth: rem(360),
      justifyContent: 'space-between',
    },
    imgCol: {
      [theme.fn.largerThan('sm')]: {
        width: '100%',
        maxWidth: rem(648),
      },
    },
    boxFrame: {
      borderRadius: rem(12),
      [theme.fn.largerThan('sm')]: {
        borderRadius: rem(24),
      },
    },
    boxFrameInner: {
      borderRadius: 'inherit',
    },
    imgHref: {
      display: 'block',
    },
    img: { borderRadius: 'inherit' },
    ctaBtn: {
      minWidth: rem(180),
    },
    disclaimerRoot: {},
    disclaimerTargetBtn: {},
    disclaimerDropdown: {},
    disclaimerIcon: {},
  }
})
